/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from '@azure/msal-browser';

export const LOGIN_TYPE = 'redirect';

const localhost = window.location.hostname === 'localhost';
/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */
// console.log('📋 ~ Here is the process.env: ', process.env);
// console.log('📋 ~ Here is the client ID : ', process.env.REACT_APP_CLIENT_ID);

export const msalConfig = {
	auth: {
		clientId: process.env.REACT_APP_CLIENT_ID,
		//clientId: "e7903ad0-e8da-4ef8-9242-f698a75b12d0",
		//authority: "https://login.microsoftonline.com/e4ca6d0a-a356-4ca7-a27d-3d416666f221",
		authority: 'https://login.microsoftonline.com/common',
		redirectUri: localhost ? 'http://localhost:3000/' : process.env.REACT_APP_REDIRECTURI
		//redirectUri: "https://red-bay-0a5d8fe10.4.azurestaticapps.net/"
		//redirectUri: process.env.REACT_APP_REDIRECTURI
	},
	cache: {
		cacheLocation: 'localStorage', // This configures where your cache will be stored
		storeAuthStateInCookie: true, // Set this to "true" if you are having issues on IE11 or Edge
	},
	system: {
		loggerOptions: {
			loggerCallback: (level, message, containsPii) => {
				if (containsPii) {
					return;
				}
				switch (level) {		
				case LogLevel.Error:
					console.error('MSAL error', message);
					return;
				case LogLevel.Info:
					// console.info('MSAL info', message);
					return;
				case LogLevel.Verbose:
					console.debug('MSAL debug', message);
					return;
				case LogLevel.Warning:
					console.warn('MSAL warning', message);
					return;
				default:
					console.log('MSAL log', message);
					return;
				}	
			}	
		}	
	}
};


export const loginRequest = {
	scopes: ['User.Read', 'Sites.ReadWrite.All' ]//, "user_impersonation"]
};